export const environment = {
  production: true,
  API_HOST: "https://fitflop.letsflo.io/api",
  Raven: "https://d44976c431af475ab264b3e6b85f76e5@sentry.io/302569",
  image_folder: "fitflop",
  heap: { enabled: true, appid: "456016258" },
  api_search_enabled: true
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts